import { Tag, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import { useListCriteria, UseListCriteriaProps } from "./useListCriteria";
import { SimpleErrorNotification, SimpleLoader } from "shared/components";

export const ListCriteria = ({ widgetFilters }: UseListCriteriaProps) => {
  const { t } = useTranslation();
  const { filteredTagData, error, loading } = useListCriteria({
    widgetFilters,
  });

  return (
    <Flex flexDir="column" gap="200">
      <Text visual="smallLabel">
        {t("widgets:DETAILS.PAGE_ACTIONS.LIST_CRITERIA")}
      </Text>
      {loading ? (
        <SimpleLoader />
      ) : error ? (
        <SimpleErrorNotification />
      ) : (
        filteredTagData.map((filter) => (
          <Flex key={filter.key} flexDir="column" gap="100">
            <Text visual={"smallSemiBold"} color={"text.mid"}>
              {t(`core:FILTER.${filter.key}.TITLE`)}
            </Text>
            <Flex
              flexDir="row"
              alignItems={"center"}
              flexWrap={"wrap"}
              gap="75"
            >
              {filter.tags.map((name: string) => (
                <Tag key={name} visual={"accent.purple"} mode={"light"}>
                  {name}
                </Tag>
              ))}
            </Flex>
          </Flex>
        ))
      )}
    </Flex>
  );
};
